import React, { useRef, useEffect, useState } from 'react';
import { Link, withRouter, useHistory, useLocation } from 'react-router-dom';
import qs from 'query-string';
import dayjs from 'dayjs';
import useInterval from 'react-useinterval';
import { useDispatch, useSelector } from 'react-redux';

import MainHeader from '@/routes/components/layout/header/mainHeader';
import LocalText from '@/localization/local_text';
import CommonRadio from '../common_radio';
import SelectLanguage from '../common_header_language';
import CommonSiteMap from '../common_siteMap';
import CommonSearchForm from '../common_searchForm';
import RadioListModal from '../../radio/common/RadioListModal';
import TvListModal from '../../tv/common/TvListModal';
import NewsScheduleMdal from '../../news/common/NewsScheduleMdal';
import NewsDailyFocusModal from '../../news/common/NewsDailyFocusModal';
import { schduleList } from '@/network/apis/apiUri';
import useAxios from '@/network/useAxios';
import { NEWS_CATEGORY, NEWS_SCHEDULE } from '@/reducer';
import getNextUrl from '@/util/get_next_url';
import NavData from '@/config/data/nav/nav_data.json';
import useContent from '@/localization/data_export';
import { program_sch } from '../../common/common_fnc';

import '../css/common_header.scss';
import HeaderBreadcrumb from '../../layout/header/header-breadcrumb';
import HeaderBreadcrumbVod from '../../layout/header/header-breadcrumb-vod';
import NewsNav from './news-nav';

const CommonHeader = (props) => {
  const locationSearch = window.location.search;
  let nav = NavData;
  let query = qs.parse(locationSearch);
  const category = query.category;
  const dispatch = useDispatch();

  const { news } = useSelector((state) => state);

  const anchorTitle = useContent(['global', 'anchor', 'title']);

  const [postData, setPostData] = useState({
    address: 'https://script.arirang.com/api/v1/bis/listScheduleV3.do',
    method: 'POST',
    headers: {},
    body: {
      data: {
        dmParam: {
          chanId: 'CH_W',
          broadYmd: dayjs.tz().format('YYYYMMDD'),
          planNo: '1',
        },
      },
    },
  });

  const tmrData = {
    ...postData,
    body: {
      data: { dmParam: { ...postData.body.data.dmParam, broadYmd: dayjs.tz().add(1, 'd').format('YYYYMMDD') } },
    },
  };
  const ystData = {
    ...postData,
    body: {
      data: { dmParam: { ...postData.body.data.dmParam, broadYmd: dayjs.tz().subtract(1, 'd').format('YYYYMMDD') } },
    },
  };

  const [scheduleList, scheduleRefetch] = useAxios(schduleList, [postData], postData, true);
  const [tmrScheduleList, tmrScheduleRefetch] = useAxios(schduleList, [postData], tmrData, true);
  const [ystScheduleList, ystScheduleRefetch] = useAxios(schduleList, [postData], ystData, true);

  const { data: scheduleData } = scheduleList;
  const { data: tmrSchData } = tmrScheduleList;
  const { data: ystSchData } = ystScheduleList;

  const [nowSchedule, setNowSchedule] = useState({});

  const header = useRef();

  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const lang = query?.lang;
    if (!lang) {
      window.history.replaceState({}, '', `${getNextUrl(window.location.href)}lang=${props.mode}`);
    }
  }, [location]);

  const gnbNews = useRef([]);

  const [scrollFlag, setScrollFlag] = useState(false);
  const handleScroll = props.throttle(updateScroll, 100);

  function updateScroll() {
    const { scrollY } = window;
    const isScrolled = scrollY > 35;
    setScrollFlag(isScrolled);
  }

  function handleGnbNews(i, arr) {
    let siblings = arr.filter((el) => el !== i);
    if (i.classList.contains('on')) {
      i.classList.remove('on');
    } else {
      i.classList.add('on');
      siblings.map((j) => j.classList.remove('on'));
    }
  }

  const businessMenu = (v) => {
    history.push({ pathname: nav['BUSINESS_GLOBAL'].path, state: v });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (header.current) scrollFlag ? header.current.classList.add('scroll') : header.current.classList.remove('scroll');
  }, [scrollFlag]);

  useEffect(() => {
    if (location.pathname.split('/')[1] === 'news') {
      let btnDepth1 = [];
      gnbNews.current.map((i) => btnDepth1.push(i.children[0]));
      btnDepth1.map((i) => i.addEventListener('click', handleGnbNews.bind(null, i, btnDepth1)));
    }
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    function checkPath(path) {
      if (location.pathname.includes(path)) return false;
      return true;
    }
    if (news.category && checkPath('news/view') && checkPath('news/genre') && checkPath('news/kogl/genre'))
      dispatch({ type: NEWS_CATEGORY, category: '' });
    if (news.schedule && checkPath('news/corner')) dispatch({ type: NEWS_SCHEDULE, schedule: '' });
  }, [location, dispatch]);

  useEffect(() => {
    setNowSchedule(program_sch(scheduleData, tmrSchData, ystSchData));
  }, [scheduleData, tmrSchData, ystSchData]);

  useEffect(() => {
    if (props.liveSort) {
      if (props.liveSort === 'WORLD') {
        setPostData({ ...postData, body: { data: { dmParam: { ...postData.body.data.dmParam, chanId: 'CH_W' } } } });
      } else if (props.liveSort === 'KOREA') {
        setPostData({ ...postData, body: { data: { dmParam: { ...postData.body.data.dmParam, chanId: 'CH_K' } } } });
      } else if (props.liveSort === 'UN') {
        setPostData({ ...postData, body: { data: { dmParam: { ...postData.body.data.dmParam, chanId: 'CH_Z' } } } });
      }
    }
  }, [props.liveSort]);

  useEffect(() => {
    if (category) {
      dispatch({ type: NEWS_CATEGORY, category: category });
    }
  }, [category]);

  useInterval(() => {
    if (dayjs.tz().format('HHmm') === nowSchedule?.next?.broadHm) {
      scheduleRefetch(postData);
      tmrScheduleRefetch({
        ...postData,
        body: {
          data: { dmParam: { ...postData.body.data.dmParam, broadYmd: dayjs.tz().add(1, 'd').format('YYYYMMDD') } },
        },
      });
      ystScheduleRefetch({
        ...postData,
        body: {
          data: {
            dmParam: { ...postData.body.data.dmParam, broadYmd: dayjs.tz().subtract(1, 'd').format('YYYYMMDD') },
          },
        },
      });
    }
  }, 3000);

  const headerContainer = () => {
    switch (location.pathname.split('/')[1]) {
      case 'radio':
        return (
          <>
            <header id="CommonHeader" className="header radio subPageStyle" ref={header}>
              <div className="header_container">
                <div className="header_container_tnb_wrap">
                  <div className="header_container_tnb">
                    <ul className="tnb">
                      <li className="tnb_list style_font">
                        <Link to={nav['HOME'].path} className="tnb_link" title={'ARIRANG'}>
                          ARIRANG
                        </Link>
                      </li>
                      <li className="tnb_list">
                        <Link to={nav['LIVE_MAIN'].path} className="tnb_link" title={'LIVE'}>
                          LIVE
                        </Link>
                      </li>
                      <li className="tnb_list">
                        <Link to={nav['NEWS_MAIN'].path} className="tnb_link" title={'NEWS'}>
                          NEWS
                        </Link>
                      </li>
                      <li className="tnb_list">
                        <Link to={nav['TV_MAIN'].path} className="tnb_link" title={'TV'}>
                          TV
                        </Link>
                      </li>
                      <li className="tnb_list active">
                        <Link to={nav['RADIO_MAIN'].path} className="tnb_link" title={'RADIO'}>
                          RADIO
                        </Link>
                      </li>
                      <li className="tnb_list">
                        <Link to={nav['VOD_MAIN'].path} className="tnb_link" title={'VOD'}>
                          VOD
                        </Link>
                      </li>
                    </ul>
                    <ul className="quick">
                      <li className="quick_list">
                        <a
                          href={`https://company.arirang.com/?lang=${props.mode}`}
                          className="quick_link"
                          target="_blank"
                          rel="noreferrer"
                          title={'About Arirang_Opens in a new window'}
                        >
                          {props.mode === 'ko' ? '재단소개' : 'About Arirang'}
                        </a>
                      </li>
                      <li className="quick_list">
                        <Link to={nav['SCHEDULE'].path} className="quick_link" title={'SCHEDULE'}>
                          {props.mode === 'ko' ? '편성표' : 'SCHEDULE'}
                        </Link>
                      </li>
                      <li className="quick_list lang">
                        <div className="quick_link">
                          {props.mode === 'ko' ? '언어' : 'LANGUAGE'}
                          <SelectLanguage />
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="header_container_gnb_wrap">
                  <div className="header_container_gnb">
                    <div className="gnb">
                      <div className="gnb_logo-wrap">
                        <div className="gnb-head">
                          <Link to="/" title={anchorTitle}>
                            <img
                              className="head-logo"
                              src={require('@/assets/images/common/logo_header_red.png').default}
                              alt=""
                            />
                          </Link>
                          <Link to={nav['RADIO_MAIN'].path} title={anchorTitle}>
                            <h1 className="head-title">RADIO</h1>
                          </Link>
                        </div>
                        <RadioListModal mode={props.mode} />
                        <div className="gnb_mainGnb style_index">
                          <div className="mainGnb_list-wrap">
                            <Link
                              className={`btnDepth2 ${
                                location.pathname.split('/')[1] === 'radio' &&
                                location.pathname.split('/')[2] === 'podcast' &&
                                'on'
                              }`}
                              to={nav['RADIO_PODCAST'].path}
                              title={anchorTitle}
                            >
                              Podcast
                            </Link>
                            <Link
                              className={`btnDepth2 ${
                                location.pathname.split('/')[1] === 'radio' &&
                                location.pathname.split('/')[2] === 'vod' &&
                                'on'
                              }`}
                              to={nav['RADIO_VOD_MAIN'].path}
                              title={anchorTitle}
                            >
                              VOD
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="gnb_content">
                        <CommonSearchForm mode={props.mode} className="style_search" />
                        <div className="commonSiteMap-wrap">
                          <CommonSiteMap styleK={true} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <HeaderBreadcrumb page={'radio'} />
              </div>
            </header>
            <CommonRadio isRadioPlay={props.isRadioPlay} setIsRadioPlay={props.setIsRadioPlay} mode={props.mode} />
          </>
        );
      case 'tv':
        return (
          <header id="CommonHeader" className="header tv subPageStyle" ref={header}>
            <div className="header_container">
              <div className="header_container_tnb_wrap">
                <div className="header_container_tnb">
                  <ul className="tnb">
                    <li className="tnb_list style_font">
                      <Link to={nav['HOME'].path} className="tnb_link" title={'arirang'}>
                        ARIRANG
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['LIVE_MAIN'].path} className="tnb_link" title={'LIVE'}>
                        LIVE
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['NEWS_MAIN'].path} className="tnb_link" title={'NEWS'}>
                        NEWS
                      </Link>
                    </li>
                    <li className="tnb_list active">
                      <Link to={nav['TV_MAIN'].path} className="tnb_link" title={'TV'}>
                        TV
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['RADIO_MAIN'].path} className="tnb_link" title={'RADIO'}>
                        RADIO
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['VOD_MAIN'].path} className="tnb_link" title={'VOD'}>
                        VOD
                      </Link>
                    </li>
                  </ul>
                  <ul className="quick">
                    <li className="quick_list">
                      <a
                        href={`https://company.arirang.com/?lang=${props.mode}`}
                        className="quick_link"
                        target="_blank"
                        rel="noreferrer"
                        title={'About Arirang_Opens in a new window'}
                      >
                        {props.mode === 'ko' ? '재단소개' : 'About Arirang'}
                      </a>
                    </li>
                    <li className="quick_list">
                      <Link to={nav['SCHEDULE'].path} className="quick_link" title={'SCHEDULE'}>
                        {props.mode === 'ko' ? '편성표' : 'SCHEDULE'}
                      </Link>
                    </li>
                    <li className="quick_list lang">
                      <div className="quick_link">
                        {props.mode === 'ko' ? '언어' : 'LANGUAGE'}
                        <SelectLanguage />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="header_container_gnb_wrap">
                <div className="header_container_gnb">
                  <div className="gnb">
                    <div className="gnb_logo-wrap">
                      <div className="gnb-head">
                        <Link to="/" title={anchorTitle}>
                          <img
                            className="head-logo"
                            src={require('@/assets/images/common/logo_header_red.png').default}
                            alt=""
                          />
                        </Link>
                        <Link to={nav['TV_MAIN'].path} title={anchorTitle}>
                          <h1 className="head-title">TV</h1>
                        </Link>
                      </div>
                      <TvListModal mode={props.mode} />
                      <div className="gnb_mainGnb style_index">
                        <div className="mainGnb_list-wrap"></div>
                      </div>
                    </div>
                    <div className="gnb_content">
                      <CommonSearchForm mode={props.mode} className="style_search" />
                      <div className="commonSiteMap-wrap">
                        <CommonSiteMap styleK={true} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <HeaderBreadcrumb page={'tv'} />
            </div>
          </header>
        );
      case 'news':
        return (
          <header id="CommonHeader" className="header news subPageStyle" ref={header}>
            <div className="header_container">
              <div className="header_container_tnb_wrap">
                <div className="header_container_tnb">
                  <ul className="tnb">
                    <li className="tnb_list style_font">
                      <Link to={nav['HOME'].path} className="tnb_link" title={'arirang'}>
                        ARIRANG
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['LIVE_MAIN'].path} className="tnb_link" title={'LIVE'}>
                        LIVE
                      </Link>
                    </li>
                    <li className="tnb_list active">
                      <Link to={nav['NEWS_MAIN'].path} className="tnb_link" title={'NEWS'}>
                        NEWS
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['TV_MAIN'].path} className="tnb_link" title={'TV'}>
                        TV
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['RADIO_MAIN'].path} className="tnb_link" title={'RADIO'}>
                        RADIO
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['VOD_MAIN'].path} className="tnb_link" title={'VOD'}>
                        VOD
                      </Link>
                    </li>
                  </ul>
                  <ul className="quick">
                    <li className="quick_list">
                      <a
                        href={`https://company.arirang.com/?lang=${props.mode}`}
                        className="quick_link"
                        target="_blank"
                        rel="noreferrer"
                        title={'About Arirang_Opens in a new window'}
                      >
                        {props.mode === 'ko' ? '재단소개' : 'About Arirang'}
                      </a>
                    </li>
                    <li className="quick_list">
                      <Link to={nav['SCHEDULE'].path} className="quick_link" title={'SCHEDULE'}>
                        {props.mode === 'ko' ? '편성표' : 'SCHEDULE'}
                      </Link>
                    </li>
                    <li className="quick_list lang">
                      <div className="quick_link">
                        {props.mode === 'ko' ? '언어' : 'LANGUAGE'}
                        <SelectLanguage />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="header_container_gnb_wrap">
                <div className="header_container_gnb">
                  <div className="gnb">
                    <div className="gnb_logo-wrap">
                      <div className="gnb-head">
                        <Link to="/" title={anchorTitle}>
                          <img
                            className="head-logo"
                            src={require('@/assets/images/common/logo_header_red.png').default}
                            alt=""
                          />
                        </Link>
                        <Link to={nav['NEWS_MAIN'].path} title={anchorTitle}>
                          <h1 className="head-title">NEWS</h1>
                        </Link>
                      </div>
                      <NewsScheduleMdal />
                      <NewsDailyFocusModal />
                    </div>
                    <div className="gnb_content">
                      <Link
                        to={nav['NEWS_VIDEO'].path}
                        className="gnb_content_btn-full-video"
                        title={'View all full videos'}
                      >
                        Latest Full Video
                      </Link>
                      <CommonSearchForm mode={props.mode} className="style_search" />
                      <div className="commonSiteMap-wrap">
                        <CommonSiteMap styleK={true} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <NewsNav />
            </div>
          </header>
        );
      case 'vod':
        return (
          <header id="CommonHeader" className="header vod subPageStyle" ref={header}>
            <div className="header_container">
              <div className="header_container_tnb_wrap">
                <div className="header_container_tnb">
                  <ul className="tnb">
                    <li className="tnb_list style_font">
                      <Link to={nav['HOME'].path} className="tnb_link" title={'arirang'}>
                        ARIRANG
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['LIVE_MAIN'].path} className="tnb_link" title={'LIVE'}>
                        LIVE
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['NEWS_MAIN'].path} className="tnb_link" title={'NEWS'}>
                        NEWS
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['TV_MAIN'].path} className="tnb_link" title={'TV'}>
                        TV
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['RADIO_MAIN'].path} className="tnb_link" title={'RADIO'}>
                        RADIO
                      </Link>
                    </li>
                    <li className="tnb_list active">
                      <Link to={nav['VOD_MAIN'].path} className="tnb_link" title={'VOD'}>
                        VOD
                      </Link>
                    </li>
                  </ul>
                  <ul className="quick">
                    <li className="quick_list">
                      <a
                        href={`https://company.arirang.com/?lang=${props.mode}`}
                        className="quick_link"
                        target="_blank"
                        rel="noreferrer"
                        title={'About Arirang_Opens in a new window'}
                      >
                        {props.mode === 'ko' ? '재단소개' : 'About Arirang'}
                      </a>
                    </li>
                    <li className="quick_list">
                      <Link to={nav['SCHEDULE'].path} className="quick_link" title={'SCHEDULE'}>
                        {props.mode === 'ko' ? '편성표' : 'SCHEDULE'}
                      </Link>
                    </li>
                    <li className="quick_list lang">
                      <div className="quick_link">
                        {props.mode === 'ko' ? '언어' : 'LANGUAGE'}
                        <SelectLanguage />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="header_container_gnb_wrap">
                <div className="header_container_gnb">
                  <div className="gnb">
                    <div className="gnb_logo-wrap">
                      <div className="gnb-head">
                        <Link to="/" title={anchorTitle}>
                          <img
                            className="head-logo"
                            src={require('@/assets/images/common/logo_header_red.png').default}
                            alt=""
                          />
                        </Link>
                        <Link to={nav['VOD_MAIN'].path} title={anchorTitle}>
                          <h1 className="head-title">
                            <span className="normal">VOD</span>
                            <span className="regular">Replay</span>
                          </h1>
                        </Link>
                      </div>
                    </div>
                    <div className="gnb_content">
                      <CommonSearchForm mode={props.mode} className="style_search" />
                      <div className="commonSiteMap-wrap">
                        <CommonSiteMap styleK={true} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <HeaderBreadcrumbVod page={'vod'} />
            </div>
          </header>
        );
      case 'live':
        return (
          <header id="CommonHeader" className="header live subPageStyle" ref={header}>
            <div className="header_container">
              <div className="header_container_tnb_wrap">
                <div className="header_container_tnb">
                  <ul className="tnb">
                    <li className="tnb_list style_font">
                      <Link to={nav['HOME'].path} className="tnb_link" title={'arirang'}>
                        ARIRANG
                      </Link>
                    </li>
                    <li className="tnb_list active">
                      <Link to={nav['LIVE_MAIN'].path} className="tnb_link" title={'LIVE'}>
                        LIVE
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['NEWS_MAIN'].path} className="tnb_link" title={'NEWS'}>
                        NEWS
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['TV_MAIN'].path} className="tnb_link" title={'TV'}>
                        TV
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['RADIO_MAIN'].path} className="tnb_link" title={'RADIO'}>
                        RADIO
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['VOD_MAIN'].path} className="tnb_link" title={'VOD'}>
                        VOD
                      </Link>
                    </li>
                  </ul>
                  <ul className="quick">
                    <li className="quick_list">
                      <a
                        href={`https://company.arirang.com/?lang=${props.mode}`}
                        className="quick_link"
                        target="_blank"
                        rel="noreferrer"
                        title={'About Arirang_Opens in a new window'}
                      >
                        {props.mode === 'ko' ? '재단소개' : 'About Arirang'}
                      </a>
                    </li>
                    <li className="quick_list">
                      <Link to={nav['SCHEDULE'].path} className="quick_link" title={'SCHEDULE'}>
                        {props.mode === 'ko' ? '편성표' : 'SCHEDULE'}
                      </Link>
                    </li>
                    <li className="quick_list lang">
                      <div className="quick_link">
                        {props.mode === 'ko' ? '언어' : 'LANGUAGE'}
                        <SelectLanguage />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="header_container_gnb_wrap">
                <div className="header_container_gnb">
                  <div className="gnb">
                    <div className="gnb-head">
                      <Link to="/" title={anchorTitle}>
                        <img
                          className="head-logo"
                          src={require('@/assets/images/common/logo_header_red.png').default}
                          alt=""
                        />
                      </Link>
                      <Link to={nav['LIVE_MAIN'].path} title={anchorTitle}>
                        <h1 className="head-title style_live">LIVE</h1>
                      </Link>
                      <p className="head-sub">{nowSchedule?.now?.pgmOnm}</p>
                    </div>
                    <div className="gnb_content">
                      <CommonSearchForm mode={props.mode} className="style_search" />
                      <div className="commonSiteMap-wrap">
                        <CommonSiteMap styleK={true} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <HeaderBreadcrumb page={'live'} />
            </div>
          </header>
        );
      case 'business':
        return (
          <header id="CommonHeader" className="header business" ref={header}>
            <div className="header_container">
              <div className="header_container_tnb_wrap">
                <div className={`header_container_tnb ${scrollFlag && 'scroll'}`}>
                  <ul className="tnb">
                    <li className="tnb_list style_font">
                      <Link to={nav['HOME'].path} className="tnb_link" title={'arirang'}>
                        ARIRANG
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['LIVE_MAIN'].path} className="tnb_link" title={'LIVE'}>
                        LIVE
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['NEWS_MAIN'].path} className="tnb_link" title={'NEWS'}>
                        NEWS
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['TV_MAIN'].path} className="tnb_link" title={'TV'}>
                        TV
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['RADIO_MAIN'].path} className="tnb_link" title={'RADIO'}>
                        RADIO
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['VOD_MAIN'].path} className="tnb_link" title={'VOD'}>
                        VOD
                      </Link>
                    </li>
                  </ul>
                  <ul className="quick">
                    <li className="quick_list">
                      <a
                        href={`https://company.arirang.com/?lang=${props.mode}`}
                        className="quick_link"
                        target="_blank"
                        rel="noreferrer"
                        title={'About Arirang_Opens in a new window'}
                      >
                        {props.mode === 'ko' ? '재단소개' : 'About Arirang'}
                      </a>
                    </li>
                    <li className="quick_list">
                      <Link to={nav['SCHEDULE'].path} className="quick_link" title={'SCHEDULE'}>
                        {props.mode === 'ko' ? '편성표' : 'SCHEDULE'}
                      </Link>
                    </li>
                    <li className="quick_list lang">
                      <div className="quick_link">
                        {props.mode === 'ko' ? '언어' : 'LANGUAGE'}
                        <SelectLanguage />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="header_container_gnb">
                <Link to="/" title={anchorTitle}>
                  <img className="logo_img" src={require('@/assets/images/common/arirang_logo.png').default} alt="" />
                </Link>
                <div className="header_container_gnb_menu menu">
                  <button type="button" className="menu_link" onClick={() => businessMenu(0)}>
                    HOME
                  </button>
                  <button type="button" className="menu_link" onClick={() => businessMenu(1)}>
                    ABOUT US
                  </button>
                  <button type="button" className="menu_link" onClick={() => businessMenu(2)}>
                    CONTENTS
                  </button>
                  <button type="button" className="menu_link" onClick={() => businessMenu(3)}>
                    HOW TO WATCH
                  </button>
                  <button type="button" className="menu_link" onClick={() => businessMenu(4)}>
                    PARTNERS
                  </button>
                  <button type="button" className="menu_link" onClick={() => businessMenu(5)}>
                    CONTACTS
                  </button>
                </div>
              </div>
            </div>
          </header>
        );
      case 'calamity':
        return (
          <header id="CommonHeader" className="header tv subPageStyle" ref={header}>
            <div className="header_container">
              <div className="header_container_tnb_wrap">
                <div className="header_container_tnb">
                  <ul className="tnb">
                    <li className="tnb_list style_font">
                      <Link to={nav['HOME'].path} className="tnb_link" title={'arirang'}>
                        ARIRANG
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['LIVE_MAIN'].path} className="tnb_link" title={'LIVE'}>
                        LIVE
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['NEWS_MAIN'].path} className="tnb_link" title={'NEWS'}>
                        NEWS
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['TV_MAIN'].path} className="tnb_link" title={'TV'}>
                        TV
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['RADIO_MAIN'].path} className="tnb_link" title={'RADIO'}>
                        RADIO
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['VOD_MAIN'].path} className="tnb_link" title={'VOD'}>
                        VOD
                      </Link>
                    </li>
                  </ul>
                  <ul className="quick">
                    <li className="quick_list">
                      <a
                        href={`https://company.arirang.com/?lang=${props.mode}`}
                        className="quick_link"
                        target="_blank"
                        rel="noreferrer"
                        title={'About Arirang_Opens in a new window'}
                      >
                        {props.mode === 'ko' ? '재단소개' : 'About Arirang'}
                      </a>
                    </li>
                    <li className="quick_list">
                      <Link to={nav['SCHEDULE'].path} className="quick_link" title={'SCHEDULE'}>
                        {props.mode === 'ko' ? '편성표' : 'SCHEDULE'}
                      </Link>
                    </li>
                    <li className="quick_list lang">
                      <div className="quick_link">
                        {props.mode === 'ko' ? '언어' : 'LANGUAGE'}
                        <SelectLanguage />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="header_container_gnb_wrap">
                <div className="header_container_gnb">
                  <div className="gnb">
                    <div className="gnb_logo-wrap">
                      <div className="gnb-head">
                        <Link to="/" title={anchorTitle}>
                          <img
                            className="head-logo"
                            src={require('@/assets/images/common/logo_header_red.png').default}
                            alt=""
                          />
                        </Link>
                        <Link to={nav['CALAMITY'].path} title={anchorTitle}>
                          <h1 className="head-title">Disaster</h1>
                        </Link>
                      </div>
                      <div className="gnb_mainGnb style_index">
                        <div className="mainGnb_list-wrap"></div>
                      </div>
                    </div>
                    <div className="gnb_content">
                      <CommonSearchForm mode={props.mode} className="style_search" />
                      <div className="commonSiteMap-wrap">
                        <CommonSiteMap styleK={true} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <HeaderBreadcrumb page={'calamity'} />
            </div>
          </header>
        );
      case 'schedule':
        return (
          <header id="CommonHeader" className="header schedule subPageStyle" ref={header}>
            <div className="header_container">
              <div className="header_container_tnb_wrap">
                <div className="header_container_tnb">
                  <ul className="tnb">
                    <li className="tnb_list style_font">
                      <Link to={nav['HOME'].path} className="tnb_link" title={'arirang'}>
                        ARIRANG
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['LIVE_MAIN'].path} className="tnb_link" title={'LIVE'}>
                        LIVE
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['NEWS_MAIN'].path} className="tnb_link" title={'NEWS'}>
                        NEWS
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['TV_MAIN'].path} className="tnb_link" title={'TV'}>
                        TV
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['RADIO_MAIN'].path} className="tnb_link" title={'RADIO'}>
                        RADIO
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['VOD_MAIN'].path} className="tnb_link" title={'VOD'}>
                        VOD
                      </Link>
                    </li>
                  </ul>
                  <ul className="quick">
                    <li className="quick_list">
                      <a
                        href={`https://company.arirang.com/?lang=${props.mode}`}
                        className="quick_link"
                        target="_blank"
                        rel="noreferrer"
                        title={'About Arirang_Opens in a new window'}
                      >
                        {props.mode === 'ko' ? '재단소개' : 'About Arirang'}
                      </a>
                    </li>
                    <li className="quick_list">
                      <Link to={nav['SCHEDULE'].path} className="quick_link" title={'SCHEDULE'}>
                        {props.mode === 'ko' ? '편성표' : 'SCHEDULE'}
                      </Link>
                    </li>
                    <li className="quick_list lang">
                      <div className="quick_link">
                        {props.mode === 'ko' ? '언어' : 'LANGUAGE'}
                        <SelectLanguage />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="header_container_gnb_wrap">
                <div className="header_container_gnb">
                  <div className="gnb">
                    <div className="gnb_logo-wrap">
                      <div className="gnb-head">
                        <Link to="/" title={anchorTitle}>
                          <img
                            className="head-logo"
                            src={require('@/assets/images/common/logo_header_red.png').default}
                            alt=""
                          />
                        </Link>
                        <Link to={nav['SCHEDULE'].path} title={anchorTitle}>
                          <h1 className="head-title">SCHEDULE</h1>
                        </Link>
                      </div>
                    </div>
                    <div className="gnb_content">
                      <CommonSearchForm mode={props.mode} className="style_search" />
                      <div className="commonSiteMap-wrap">
                        <CommonSiteMap styleK={true} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <HeaderBreadcrumb page={'schedule'} />
            </div>
          </header>
        );
      case 'search':
        return (
          <header id="CommonHeader" className="header search subPageStyle" ref={header}>
            <div className="header_container">
              <div className="header_container_tnb_wrap">
                <div className="header_container_tnb">
                  <ul className="tnb">
                    <li className="tnb_list style_font">
                      <Link to={nav['HOME'].path} className="tnb_link" title={'arirang'}>
                        ARIRANG
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['LIVE_MAIN'].path} className="tnb_link" title={'LIVE'}>
                        LIVE
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['NEWS_MAIN'].path} className="tnb_link" title={'NEWS'}>
                        NEWS
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['TV_MAIN'].path} className="tnb_link" title={'TV'}>
                        TV
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['RADIO_MAIN'].path} className="tnb_link" title={'RADIO'}>
                        RADIO
                      </Link>
                    </li>
                    <li className="tnb_list">
                      <Link to={nav['VOD_MAIN'].path} className="tnb_link" title={'VOD'}>
                        VOD
                      </Link>
                    </li>
                  </ul>
                  <ul className="quick">
                    <li className="quick_list">
                      <a
                        href={`https://company.arirang.com/?lang=${props.mode}`}
                        className="quick_link"
                        target="_blank"
                        rel="noreferrer"
                        title={'About Arirang_Opens in a new window'}
                      >
                        {props.mode === 'ko' ? '재단소개' : 'About Arirang'}
                      </a>
                    </li>
                    <li className="quick_list">
                      <Link to={nav['SCHEDULE'].path} className="quick_link" title={'SCHEDULE'}>
                        {props.mode === 'ko' ? '편성표' : 'SCHEDULE'}
                      </Link>
                    </li>
                    <li className="quick_list lang">
                      <div className="quick_link">
                        {props.mode === 'ko' ? '언어' : 'LANGUAGE'}
                        <SelectLanguage />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="header_container_gnb_wrap">
                <div className="header_container_gnb">
                  <div className="gnb">
                    <div className="gnb_logo-wrap">
                      <h1 className="gnb_logo">
                        <Link className="logo" to={nav['SEARCH_MAIN'].path} title={anchorTitle}>
                          <img
                            className="logo_img"
                            src={require('@/assets/images/common/logo_header_red.png').default}
                            alt=""
                          />
                          <p className="logo_txt">SEARCH</p>
                        </Link>
                      </h1>
                      <div className="gnb_mainGnb style_index">
                        <div className="mainGnb_list-wrap"></div>
                      </div>
                    </div>
                    <div className="gnb_content">
                      <div className="commonSiteMap-wrap">
                        <CommonSiteMap styleK={true} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <HeaderBreadcrumb page={'search'} />
            </div>
          </header>
        );
      case '':
        return <MainHeader />;
      default:
        return (
          <header id="CommonHeader" className="header default" ref={header}>
            <div className="header_container">
              <div className="header_container_content">
                <h1 className="header_container_logo">
                  <Link to={nav['HOME'].path} title={anchorTitle}>
                    <img
                      className="headerLogo"
                      src={require('@/assets/images/common/logo_header_red.png').default}
                      alt=""
                    />
                  </Link>
                </h1>
                <div className="header_container_gnb">
                  <ul className="gnb">
                    <li className="gnb_dp1">
                      <Link to={nav['LIVE_MAIN'].path} className="gnb_link" title={anchorTitle}>
                        LIVE
                      </Link>
                    </li>
                    <li className="gnb_dp1 news">
                      <Link to={nav['NEWS_MAIN'].path} className="gnb_link gnb_link_news" title={anchorTitle}>
                        NEWS
                      </Link>
                      <ul className="gnb_dp2">
                        <li className="gnb_dp2_list">
                          <Link to="/" className="gnb_link" title={anchorTitle}>
                            COVID-19
                          </Link>
                        </li>
                        <li className="gnb_dp2_list">
                          <Link to="/" className="gnb_link" title={anchorTitle}>
                            Nat'l/Politics
                          </Link>
                        </li>
                        <li className="gnb_dp2_list">
                          <Link to="/" className="gnb_link" title={anchorTitle}>
                            North Korea
                          </Link>
                        </li>
                        <li className="gnb_dp2_list">
                          <Link to="/" className="gnb_link" title={anchorTitle}>
                            Economy
                          </Link>
                        </li>
                        <li className="gnb_dp2_list">
                          <Link to="/" className="gnb_link" title={anchorTitle}>
                            IT/Science
                          </Link>
                        </li>
                        <li className="gnb_dp2_list">
                          <Link to="/" className="gnb_link" title={anchorTitle}>
                            Foreign Policy
                          </Link>
                        </li>
                        <li className="gnb_dp2_list">
                          <Link to="/" className="gnb_link" title={anchorTitle}>
                            World
                          </Link>
                        </li>
                        <li className="gnb_dp2_list">
                          <Link to="/" className="gnb_link" title={anchorTitle}>
                            Life/Culture
                          </Link>
                        </li>
                        <li className="gnb_dp2_list">
                          <Link to="/" className="gnb_link" title={anchorTitle}>
                            Sports
                          </Link>
                        </li>
                        <li className="gnb_dp2_list">
                          <Link to="/" className="gnb_link" title={anchorTitle}>
                            Weather
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="gnb_dp1 tv">
                      <Link to={nav['TV_MAIN'].path} className="gnb_link" title={anchorTitle}>
                        TV
                      </Link>
                      <ul className="gnb_dp2">
                        <li className="gnb_dp2_list">
                          <Link to="/" className="gnb_link" title={anchorTitle}>
                            Current Affairs
                          </Link>
                        </li>
                        <li className="gnb_dp2_list">
                          <Link to="/" className="gnb_link" title={anchorTitle}>
                            Culture
                          </Link>
                        </li>
                        <li className="gnb_dp2_list">
                          <Link to="/" className="gnb_link" title={anchorTitle}>
                            Entertainment
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="gnb_dp1">
                      <Link to={nav['RADIO_MAIN'].path} className="gnb_link" title={anchorTitle}>
                        RADIO
                      </Link>
                    </li>
                    <li className="gnb_dp1 vod">
                      <Link to={nav['VOD_MAIN'].path} className="gnb_link" title={anchorTitle}>
                        VOD
                      </Link>
                      <ul className="gnb_dp2">
                        <li className="gnb_dp2_list">
                          <Link to="/" className="gnb_link" title={anchorTitle}>
                            Latest CLIP
                          </Link>
                        </li>
                        <li className="gnb_dp2_list">
                          <Link to="/" className="gnb_link" title={anchorTitle}>
                            Most Popular
                          </Link>
                        </li>
                        <li className="gnb_dp2_list">
                          <Link to="/" className="gnb_link" title={anchorTitle}>
                            Recommended CLIP
                          </Link>
                        </li>
                        <li className="gnb_dp2_list">
                          <Link to="/" className="gnb_link" title={anchorTitle}>
                            TREND
                          </Link>
                        </li>
                        <li className="gnb_dp2_list">
                          <Link to="/" className="gnb_link" title={anchorTitle}>
                            VR
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <CommonSearchForm mode={props.mode} className="/" />
                </div>
              </div>
              <div className="header_container_subGnb">
                <ul className="subGnb">
                  <li className="subGnb_dp1_list">
                    <a
                      href={`https://company.arirang.com/?lang=${props.mode}`}
                      className="quick_link"
                      target="_blank"
                      rel="noreferrer"
                      title={anchorTitle}
                    >
                      <LocalText txt={'header_kibf'} />
                    </a>
                  </li>
                  <li className="subGnb_dp1_list">
                    <Link to={nav['SCHEDULE'].path} className="subGnb_link" title={anchorTitle}>
                      <LocalText txt={'header_schedule'} />
                    </Link>
                  </li>
                  <li className="subGnb_dp1_list">
                    <Link to="/" className="subGnb_link headerLangIco" title={anchorTitle}>
                      <LocalText txt={'header_language'} />
                      <SelectLanguage />
                    </Link>
                  </li>
                  <li className="subGnb_dp1_list btnSiteMap-wrap">
                    <CommonSiteMap />
                  </li>
                </ul>
              </div>
            </div>
          </header>
        );
    }
  };

  return headerContainer();
};

export default withRouter(CommonHeader);
